import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import { useCurrentBrandData } from "lib/auth/currentUserHooks";

type Props = Omit<BoxProps, "children"> & {
  fallback?: ReactNode;
};

export default function BrandName({
  fallback = "current brand",
  ...rest
}: Props) {
  const brand = useCurrentBrandData();
  return (
    <Box as="span" {...rest}>
      {brand?.name || fallback}
    </Box>
  );
}
